import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { useApi, errMsg } from "@/lib/api";
import { PasswordDialog } from "@/components/PasswordDialog";

export const PasswordPanel = ({ user }) => {
  const api = useApi();
  const [pwd, setPwd] = useState("");
  const [mail, setMail] = useState(true);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const [show, setShow] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const r = await api("post", `/sp/users/${user.id}/password`, { password: pwd, send_email: mail }); setRes({ ...r, email: user.email }); setPwd(""); toast.success("Mot de passe modifié dans Sehatic-Pedia"); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="bg-white border border-stone-200 rounded-lg p-6 space-y-3 text-sm" data-testid="password-panel">
      <h3 className="font-heading text-base font-bold text-stone-900 flex items-center gap-2"><KeyRound className="h-4 w-4 text-[#C2410C]" /> Mot de passe</h3>
      <p className="text-stone-600">Le mot de passe actuel est chiffré et ne peut pas être affiché. Vous pouvez en définir un nouveau : il vous sera montré une fois.</p>
      <div className="flex flex-wrap gap-2">
        <Input type={show ? "text" : "password"} autoComplete="new-password" value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="Vide = mot de passe généré" className="max-w-xs" data-testid="password-input" />
        <Button type="button" variant="outline" onClick={() => setShow(!show)} data-testid="password-toggle">{show ? "Masquer" : "Voir"}</Button>
        <Button type="submit" disabled={busy || (pwd && pwd.length < 8)} className="bg-[#C2410C] hover:bg-[#9A3412] text-white" data-testid="password-submit">Définir le mot de passe</Button>
      </div>
      <label className="flex items-center gap-2 text-stone-700"><Checkbox checked={mail} onCheckedChange={(v) => setMail(!!v)} data-testid="password-email-checkbox" /> L'envoyer par e-mail à {user.email}</label>
      <PasswordDialog data={res} onClose={() => setRes(null)} />
    </form>
  );
};
